import {
  LOAD_LINE_FORM_DETAIL_SUCCESS,
} from './actions'

const initialState = {
  formDetail: {
    contact: "",
    homeAddressDetail: "",
    information: "",
    learnSubject: "",
    lineTutorCustomer: "",
    location: "",
    moreDetail: "",
    otherlearnSubject: "",
    outdoorAddressDetail: "",
    price: 0,
    published: 0,
    sendLine: 0,
    startTime: "",
    studyDate: "",
    totalHour: "",
    totalStudent: "",
    tutor: null,
    tutorGender: "",
    loadSuccess: false,
    _id: '',
    active: '',
    school: '',
    jobId: '',
    priceSell: '',
  },
}

const lineFormDetail = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_LINE_FORM_DETAIL_SUCCESS: {
      return {
        ...state,
        formDetail: {
          ...state.formDetail,
          // loadSuccess: true,
          ...action.payload,
        },
      }
    }
    default:
      return state
  }
}

export default lineFormDetail



// WEBPACK FOOTER //
// ./src/components/LineFormDetail/reducer.js